import { FunctionComponent } from 'react'
import { useTranslation } from 'react-i18next'
import Dialog from '@/components/_custom/Dialog/Dialog'
import DialogHeader from '@/components/_custom/DialogHeader/DialogHeader'
import DialogBody from '@/components/_custom/DialogBody/DialogBody'
import ButtonTextIcon from '@/components/_custom/Buttons/ButtonTextIcon/ButtonTextIcon'
import styles from './childListWithoutDaycareDialog.module.scss'
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material'
import { Close } from '@mui/icons-material'
import moment from 'moment-timezone'
import { Child } from '@/types/Child'

interface ChildListDialogProps {
    isDialogOpen: boolean
    handleCloseDialog: () => void
    childs: Child[]
}

const ChildListWithoutDaycareDialog: FunctionComponent<ChildListDialogProps> = ({
    isDialogOpen,
    handleCloseDialog,
    childs
}: ChildListDialogProps) => {
    const { t } = useTranslation()

    return (
        <Dialog open={isDialogOpen} handleClose={handleCloseDialog} className={styles.Dialog}>
            <DialogHeader title={t('childList')} />
            <DialogBody className={styles.DialogBody}>
                <TableContainer className={styles.TablePlacement}>
                    <Table className={styles.Table}>
                        <TableHead className={styles.TableHeader}>
                            <TableRow>
                                <TableCell>{t('lastname')}</TableCell>
                                <TableCell>{t('birthdate')}</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {childs.length === 0 ? (
                                <TableRow>
                                    <TableCell colSpan={2}>{t('noChilds')}</TableCell>
                                </TableRow>
                            ) : (
                                childs.map(({ firstname, birthdate }, index) => (
                                    <TableRow key={index}>
                                        <TableCell>
                                            {firstname ? firstname : <Close className={styles.CloseIcon} />}
                                        </TableCell>
                                        <TableCell>
                                            {birthdate ? (
                                                moment(birthdate, 'DD-MM-YYYY').format('DD/MM/YYYY')
                                            ) : (
                                                <Close className={styles.CloseIcon} />
                                            )}
                                        </TableCell>
                                    </TableRow>
                                ))
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
                <div className={styles.ButtonContainer}>
                    <ButtonTextIcon type={'close'} onClick={handleCloseDialog} className={styles.Button} />
                </div>
            </DialogBody>
        </Dialog>
    )
}

export default ChildListWithoutDaycareDialog
